import { createContext, useContext } from 'react';
import type { MentionSource } from './types';

export const MentionSourceContext = createContext<MentionSource[]>([]);

export function useMentionSources(): MentionSource[] {
  return useContext(MentionSourceContext);
}
